import { Heading, Link } from '@apollo/orbit';
import React from 'react';

import ImageAstronaut from 'src/assets/icon-astronaut-1.svg';
import ImagePlanetWithStars from 'src/assets/icon-planet-with-stars.svg';
import ImageTelescope from 'src/assets/icon-telescope.svg';

const images = {
  telescope: ImageTelescope,
  planetWithStars: ImagePlanetWithStars,
  astronaut: ImageAstronaut,
};

interface Props {
  image?: keyof typeof images;
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
}

export const NotFound = ({ image = 'telescope', title, subtitle }: Props) => {
  const Image = images[image];

  return (
    <div className="flex size-full items-center justify-center">
      {/*
       * `text-primary` is set here rather than left to inherit: several
       * callers render `<NotFound />` into a subtree that sets no color of
       * its own, so the subtitle fell back to the default and disappeared in
       * dark mode. `Heading` and `Link` set their own colors, which is why
       * only the surrounding prose was affected.
       */}
      <div className="max-w-md text-center text-primary">
        <Image className="mb-10 text-icon-primary" aria-hidden="true" />
        <Heading as="h2" size="2xl" className="mb-4">
          {title || 'Page not found'}
        </Heading>
        <div>
          {subtitle || (
            <>
              Huh! Looks like we can't find the page you're trying to reach, try{' '}
              <Link to="/">going home</Link>.
            </>
          )}
        </div>
      </div>
    </div>
  );
};
